'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _profileHeader = require('./profile-header');

var _profileHeader2 = _interopRequireDefault(_profileHeader);

var _practiceProfileHeader = require('../../src/styles/practice-profile-header.scss');

var _practiceProfileHeader2 = _interopRequireDefault(_practiceProfileHeader);

var _practice = require('../../src/img/practice.png');

var _practice2 = _interopRequireDefault(_practice);

var _nhs = require('../../src/img/nhs.png');

var _nhs2 = _interopRequireDefault(_nhs);

var _practiceBg = require('../../src/img/practice-bg.png');

var _practiceBg2 = _interopRequireDefault(_practiceBg);

var _practiceCover = require('../../src/img/practice-cover.png');

var _practiceCover2 = _interopRequireDefault(_practiceCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PracticeProfileHeader = function PracticeProfileHeader(props) {
	return _react2.default.createElement(
		_profileHeader2.default,
		{
			type: 'practice',
			name: props.name,
			profileImage: props.profileImage || _practice2.default,
			profileImageBackground: _practiceBg2.default,
			averageRating: props.averageRating,
			totalReviews: props.totalReviews,
			backgroundImage: props.backgroundImage || _practiceCover2.default,
			photos: props.photos,
			onStarsClick: props.onStarsClick,
			onAddReview: props.onAddReview,
			className: props.className },
		_react2.default.createElement('img', { className: _practiceProfileHeader2.default.practiceIcon, src: props.isNhs ? _nhs2.default : _practice2.default })
	);
};

PracticeProfileHeader.propTypes = {
	name: require('react').PropTypes.string.isRequired,
	profileImage: require('react').PropTypes.string.isRequired,
	averageRating: require('react').PropTypes.number.isRequired,
	totalReviews: require('react').PropTypes.number.isRequired,
	backgroundImage: require('react').PropTypes.string.isRequired,
	photos: require('react').PropTypes.arrayOf(require('react').PropTypes.string).isRequired,
	isNhs: require('react').PropTypes.bool.isRequired,
	onStarsClick: require('react').PropTypes.func.isRequired,
	onAddReview: require('react').PropTypes.func.isRequired,
	className: require('react').PropTypes.string.isRequired
};
PracticeProfileHeader.defaultProps = {
	profileImage: _practice2.default,
	isNhs: false
};

exports.default = PracticeProfileHeader;


// WEBPACK FOOTER //
// ./components/profile-header/lib/components/practice-profile-header.js